module.exports = __webpack_public_path__ + "img/icon_map_hgt_c.e546eb26.png";